export function initializeColumnsSMSNotications() {
  return [
    {
      header: 'Id',
      accessorKey: 'id',
    },
    {
      header: 'Template Name',
      accessorKey: 'name',
    },
    {
      header: 'Type',
      accessorKey: 'type',
    },
  ];
}
